export default "__VITE_ASSET__CUsuIwi7__"